import { Pipe, PipeTransform } from '@angular/core';

const defaultLimit = 225;

@Pipe({ name: 'cxTruncate' })
/**
 * example usage {{ exampleString | cxTruncate: [1, '***'] }}
 */
export class TruncatePipe implements PipeTransform {
  transform(value: string, args?: [number, string?]): string {
    if (!args) {
      return value;
    }

    let trail = '...';

    const limit = args.length > 0 && args[0] && Number.isInteger(+args[0]) ? args[0] : defaultLimit;

    if (args.length > 1 && args[1] !== undefined) {
      trail = args[1];
    }

    if (value) {
      return value.length > limit ? value.substring(0, limit) + trail : value;
    }
  }
}
